<template>
  <div>
    <div v-if="mixcloud">
      <quick-alert-modal v-bind="mixcloud_deauth_quick_alert" />
      <basic-portlet>
        <div v-if="mixcloud.user.cover_pictures">
          <div id="cover" :style="{ backgroundImage: 'url(' + mixcloud.user.cover_pictures['1113wx160h'] + ')' }" />
        </div>
        <div v-else>
          <div id="cover" :style="{ backgroundImage: 'url(' + '/build/media/misc/mixcloud_no_cover_1113x160.png' + ')' }" />
        </div>
        <br>
        <div class="kt-portlet__body kt-portlet__body--fit-y">
          <div class="kt-widget kt-widget--user-profile-1">
            <div class="kt-widget__head">
              <div class="kt-widget__media">
                <img v-if="!mixcloud.user.pictures.large" src="/build/media/misc/blank_user.png" alt="mixcloud profile picture">
                <img v-if="mixcloud.user.pictures.large" :src="mixcloud.user.pictures.large" alt="mixcloud profile picture">
              </div>
              <div class="kt-widget__content">
                <div class="kt-widget__section">
                  <span style="color: black" class="kt-widget__username">
                    {{ mixcloud.user.username }}
                  </span> <span v-if="mixcloud.user.is_pro">
                    <i style="color: rgb(52,129,167);" class="fa fa-star" /><span style="font-size: 10px">PRO</span>
                  </span>
                  <span class="kt-widget__subtitle">
                    {{ mixcloud.user.follower_count }} Followers
                  </span>
                </div>
                <a target="_blank" :href="mixcloud.user.url" class="btn btn-ss-standout">
                  Visit Mixcloud Profile
                </a>
                <a target="_blank" class="btn btn-ss-danger"
                   @click="deauthorise()">
                  Deauthorise
                </a>
              </div>
            </div>
            <tabs>
              <tab id="cloudcasts" icon="fa fa-cloud" name="Mixcloud Items">
                <mixcloud-cloudcasts />
              </tab>
            </tabs>
          </div>
        </div>
      </basic-portlet>
    </div>

    <div v-else>
      <mixcloud-linked v-if="is_link_request" :link-is-success="link_is_success"
                       :mixcloud-key="mixcloud_key"
                       :item-uuid="item_uuid" />
      <mixcloud-deauthorised v-else-if="mixcloud_deathorised" />
      <mixcloud-error v-else />
    </div>
  </div>
</template>

<script>

import BasicPortlet from 'VueComponents/BasicPortlet.vue';
import Tab from "VuePartials/App/Preferences/Tab";
import Tabs from "VuePartials/App/Preferences/Tabs";
import MixcloudCloudcasts from "VuePartials/Mixcloud/Cloudcasts";
import MixcloudDeauthorised from "VuePartials/Mixcloud/Deauthorised";
import MixcloudLinked from "VuePartials/Mixcloud/Linked";
import MixcloudError from "VuePartials/Mixcloud/Error";

export default {
  components: {
    BasicPortlet,
    Tab,
    Tabs,
    MixcloudCloudcasts,
    MixcloudDeauthorised,
    MixcloudLinked,
    MixcloudError,
  },
  data: () => ({
    mixcloud: window.mixcloud,
    is_link_request: false,
    link_is_success: window.mixcloud_link_is_success,
    mixcloud_key: null,
    mixcloud_deathorised: false,
    url_params: null,
    item_uuid: null,
    mixcloud_deauth_quick_alert: {
      title: 'Deauthorise',
      message: 'Your Timbre account will be deauthorised from Mixcloud.',
      showCancel: true,
    },
  }),

  beforeMount() {
    const urlParams = new URLSearchParams(window.location.search);
    this.is_link_request = urlParams.get('is_link_request');
    this.mixcloud_key = urlParams.get('mixcloud_key');
    this.item_uuid = urlParams.get('item_uuid');
    this.mixcloud_deathorised = urlParams.get('deauthorised');
  },

  methods: {
    async deauthorise() {
      const response = await this.quickAlert(this.mixcloud_deauth_quick_alert);

      if (response.data.confirm) {
        window.open('/mixcloud/deauthorise', "_self");
      }
    },
  },

};
</script>

<style scoped>
  #cover {
    height: 200px;
    width: 100%;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

</style>
